import { observer } from 'mobx-react-lite'
import { type OverachieverDialogViewModel } from './OverachieverDialogViewModel'
import { OverachieverDialog } from '@/features/opportunities/OverachieverDialog'

export interface OverachieverDialogContainerProps {
  vm: OverachieverDialogViewModel
}

export const OverachieverDialogContainer = observer(
  function OverachieverDialogContainer({
    vm,
  }: OverachieverDialogContainerProps) {
    return (
      <OverachieverDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onFinishOpenJobs={vm.finishOpenJobs}
        globalJobCapacity={vm.globalJobCapacity}
      />
    )
  },
)
